<script lang="ts" setup>
import { useFeatureToggle } from '@environment/useFeatureToggle';
import { type ParsedBreadcrumb } from './types';
import VBreadcrumbItem from './VBreadcrumbItem.vue';

const props = withDefaults(
  defineProps<{
    items?: ParsedBreadcrumb[];
  }>(),
  {
    items: () => [],
  },
);

const nieuwDashboard = useFeatureToggle('NieuwDashboardToggle');
</script>

<template>
  <nav class="flex @container/breadcrumb" aria-label="breadcrumbs">
    <ul class="flex overflow-hidden">
      <VBreadcrumbItem :link="nieuwDashboard ? `/app/aanvraag/recente-activiteiten/` : `/content/`">
        Dashboard
      </VBreadcrumbItem>

      <VBreadcrumbItem
        v-for="{ link, name, target } in props.items"
        :key="name"
        :link="link"
        :target="target"
      >
        {{ name }}
      </VBreadcrumbItem>
    </ul>
  </nav>
</template>
